import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import TransomConfigurator from './../TransomConfigurator';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XP44Mast extends Component {
    constructor(props) {
        super(props);
        this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this);
    }

    handleMastAndBoomChange(newValue) {
        let configuration = this.props.configuration;
        configuration.MastAndBoom = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2780, height: 965 }} transform={
                [
                    0.071489, -0.001427, 0, -0.000032,
                    0.012064, 0.088505, 0, 0.000043,
                    0, 0, 1, 0,
                    207, 355, 0, 1
                ]}>
                <ConfiguratorImage boat="XP44" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        if (this.props.configuration.BathingPlatform.value === 1) {
            image = <ConfiguratorImage boat="XP44" configuration={this.props.configuration} options={imageOptions} />;
        }

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Mast & boom' /></h1>

                    <h2><Trans defaults='Finish' /></h2>

                    <RadioGroup options={this.props.mastAndBoomOptions} value={this.props.configuration.MastAndBoom} onChange={this.handleMastAndBoomChange} />

                    <p><Trans defaults='**for optional furlerboom, please contact your local X-Yachts Dealer.' /></p>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP44Mast);


// WEBPACK FOOTER //
// ./src/XP44/XP44Mast.js